module.exports = __webpack_public_path__ + "img/avatar2.f282bd9c.png";